import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5da88f84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ConstructionAddOne" }
const _hoisted_2 = { class: "form-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red-color" }, "*"),
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "无合同说明")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red-color" }, "*"),
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "图片")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_7 = { class: "submit-btn" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 提交 ")

import { ref } from 'vue'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const uploaderValue = ref([])
const onSubmit = () => {
  router.push('construction-add')
}

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_bottom_button = _resolveComponent("bottom-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_form, { onSubmit: onSubmit }, {
        default: _withCtx(() => [
          _createVNode(_component_van_cell_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_cell, {
                title: "项目名称",
                value: "XX学校厨具销售"
              }),
              _createVNode(_component_van_cell_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_van_cell, { title: "无合同说明" }, {
                    title: _withCtx(() => [
                      _hoisted_3
                    ]),
                    label: _withCtx(() => [
                      _createVNode(_component_van_field, {
                        rows: "2",
                        autosize: "",
                        type: "textarea",
                        placeholder: "请输入说明",
                        "show-word-limit": ""
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_4,
              _createVNode(_component_van_cell_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_van_cell, { title: "图片" }, {
                    title: _withCtx(() => [
                      _hoisted_5
                    ]),
                    label: _withCtx(() => [
                      _createVNode(_component_van_uploader, {
                        modelValue: uploaderValue.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((uploaderValue).value = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_6
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_bottom_button, {
              round: "",
              block: "",
              type: "primary",
              "native-type": "submit"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})